import sensors from "sa-sdk-javascript"
import config from "../config/env"

const initSensors = function (userId) {
  // 神策埋点初始化
  sensors.init({
    server_url: config.SENSOR_HOST,
    heatmap: {
      clickmap: "default",
      scroll_notice_map: "not_collect",
    },
    is_track_single_page: false, // SPA采集开关
    use_app_track: true, // 打通App 和 H5
  })

  sensors.quick("autoTrack", {
    ActName: config.ACT_NAME,
    page_name: config.PAGE_NAME,
    ShareUserId: userId || "",
  })

  //公共属性
  sensors.registerPage({
    platform_type: config.PLATFORM,
    ActName: config.ACT_NAME,
    page_name: config.PAGE_NAME,
  })
}
// 事件
const trackEvent = function (ActButtonName, name = "ActClick") {
  try {
    sensors.track(name, {
      ActButtonName,
      ShareUserId: sessionStorage.getItem("userId") || "",
    })
  } catch (error) {
    console.log(error)
  }
}

export { initSensors, trackEvent }
